import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { Fragment, createElement } from "react";
import { rem } from "./auth-service-tools172.js";
import { getFontSize } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { InputDescription } from "./auth-service-tools300.js";
import { InputError } from "./auth-service-tools301.js";
import { InputLabel } from "./auth-service-tools302.js";
import { InputWrapperProvider } from "./auth-service-tools304.js";
import { getInputOffsets } from "./auth-service-tools307.js";
import classes from "./auth-service-tools306.js";
import { useId } from "./auth-service-tools271.js";
const defaultProps = {
  labelElement: "label",
  inputContainer: children => children,
  inputWrapperOrder: ["label", "description", "input", "error"]
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    size
  } = _ref;
  return {
    label: {
      "--input-label-size": getFontSize(size),
      "--input-asterisk-color": void 0
    },
    error: {
      "--input-error-size": size === void 0 ? void 0 : `calc(${getFontSize(size)} - ${rem(2)})`
    },
    description: {
      "--input-description-size": size === void 0 ? void 0 : `calc(${getFontSize(size)} - ${rem(2)})`
    }
  };
});
const InputWrapper = factory((_props, ref) => {
  const props = useProps("InputWrapper", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    size,
    variant,
    __staticSelector,
    inputContainer,
    inputWrapperOrder,
    label,
    error,
    description,
    labelProps,
    descriptionProps,
    errorProps,
    labelElement,
    children,
    withAsterisk,
    id,
    required,
    __stylesApiProps,
    mod,
    ...others
  } = props;
  const getStyles = useStyles({
    name: ["InputWrapper", __staticSelector],
    props: __stylesApiProps || props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  const sharedProps = {
    size,
    variant,
    __staticSelector
  };
  const idBase = useId(id);
  const isRequired = typeof withAsterisk === "boolean" ? withAsterisk : required;
  const errorId = (errorProps == null ? void 0 : errorProps.id) || `${idBase}-error`;
  const descriptionId = (descriptionProps == null ? void 0 : descriptionProps.id) || `${idBase}-description`;
  const inputId = idBase;
  const hasError = !!error && typeof error !== "boolean";
  const hasDescription = !!description;
  const _describedBy = `${hasError ? errorId : ""} ${hasDescription ? descriptionId : ""}`;
  const describedBy = _describedBy.trim().length > 0 ? _describedBy.trim() : void 0;
  const labelId = (labelProps == null ? void 0 : labelProps.id) || `${idBase}-label`;

  const _label = label && /* @__PURE__ */jsxRuntimeExports.jsx(InputLabel, {
    labelElement,
    id: labelId,
    htmlFor: inputId,
    required: isRequired,
    ...sharedProps,
    ...labelProps,
    children: label
  }, "label");

  const _description = hasDescription && /* @__PURE__ */jsxRuntimeExports.jsx(InputDescription, { ...descriptionProps,
    ...sharedProps,
    size: (descriptionProps == null ? void 0 : descriptionProps.size) || sharedProps.size,
    id: (descriptionProps == null ? void 0 : descriptionProps.id) || descriptionId,
    children: description
  }, "description");

  const _input = /* @__PURE__ */jsxRuntimeExports.jsx(Fragment, {
    children: inputContainer(children)
  }, "input");

  const _error = hasError && /* @__PURE__ */createElement(InputError, { ...errorProps,
    ...sharedProps,
    size: (errorProps == null ? void 0 : errorProps.size) || sharedProps.size,
    key: "error",
    id: (errorProps == null ? void 0 : errorProps.id) || errorId
  }, error);

  const content = inputWrapperOrder.map(part => {
    switch (part) {
      case "label":
        return _label;

      case "input":
        return _input;

      case "description":
        return _description;

      case "error":
        return _error;

      default:
        return null;
    }
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(InputWrapperProvider, {
    value: {
      getStyles,
      describedBy,
      inputId,
      labelId,
      ...getInputOffsets(inputWrapperOrder, {
        hasDescription,
        hasError
      })
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
      ref,
      variant,
      size,
      mod: [{
        error: !!error
      }, mod],
      ...getStyles("root"),
      ...others,
      children: content
    })
  });
});
InputWrapper.classes = classes;
InputWrapper.displayName = "@mantine/core/InputWrapper";
export { InputWrapper };